<main class="logout-page" aria-busy="true" aria-live="polite">
  <div class="auth-spinner" aria-hidden="true"></div>
</main>
